<template>
  <div class="quizProgress">
    <a-progress :percent="$store.state.progress" strokeLinecap="square" :show-info="false" />
  </div>
</template>

<script>
export default {
  name: "Progress",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@progressHeight: var(--progress_height);
@strokeColor: #CB2589;
@trailColor: #EBAACB;
.quizProgress{
  // position: absolute;
  position: fixed;
  bottom: 0px;
  z-index: 10;
  // bottom: 1px;
  height: @progressHeight;
  width: 100%;
  .ant-progress-inner{
    border-radius: 0;
    background-color: @trailColor;
    .ant-progress-success-bg, .ant-progress-bg{
      height: @progressHeight!important;
      background-color: @strokeColor;
    }
  }
}
</style>
